import React , {useState} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage , pageLoaded, reportAnalytics, setSelectedTimeSlots,  updateTechnicianTimeSlot, showMoreTimeSlots, setIsDisplayShowMoreBtn, getTechnicianTimeSlots} from '../TechnicianUpdatesBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import TechnicianTimeSlots from '../Shared/TechnicianTimeSlots/TechnicianTimeSlots';

const TechnicianTimeSlotsPage = (props) => {
  const [showNotChooseTimeSlotErrorMsg , setShowNotChooseTimeSlotErrorMsg] = useState(false);

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);
    if(props.selectedTimeSlots?.length == 0){     
        props.setSelectedTimeSlots(props.technicianTimeSlots?.timeSlots[0]);
    }
    props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_5", eventLabel: props.technicianTimeSlots?.timeSlots[0]?.type});
    
    if (runSideEffects()) {
    }

  }, []);


  useExtendedEffect((runSideEffects) => { 
    if(props.technicianTimeSlotPage.timeSlots.length == props.technicianTimeSlots.timeSlots.length){
      props.setIsDisplayShowMoreBtn(false);
    }
    if (runSideEffects()) {
    }
  }, [props.technicianTimeSlotPage.timeSlots]);

  function onSelectedTimeSlot(timeSlot){
      props.setSelectedTimeSlots(timeSlot);
      setShowNotChooseTimeSlotErrorMsg(false);
      props.pageLoaded();
  }

  async function updateTechnicianVisit(){
    props.reportAnalytics({eventCategory: 'technician_update', eventAction: "click_2", eventLabel: "element_6"});

    if(props.currentSelectedTimeSlot == null){
      setShowNotChooseTimeSlotErrorMsg(true);
      props.reportAnalytics({
        eventCategory: 'technician_update',
        eventAction: "visibility_6",
        eventLabel: "element_7",
      });
    }
    else{
      var request = {
        SlotInfoCellcom: null,
        SlotInfoBezeq: null
      }
      if(props.selectedTimeSlots.length > 0){
        props.selectedTimeSlots.forEach( timeSlot => {
          var slot = {
            OrderId: timeSlot.orderId,
            StartDate: timeSlot.startDate,
            EndTime: timeSlot.endTime,
            StartTime: timeSlot.startTime,
            StartDateTime: timeSlot.startDateTime
          }      
          if(timeSlot.type == "BEZEQ"){
            request.SlotInfoBezeq = slot;
          }
          if(timeSlot.type == "CELLCOM"){
            request.SlotInfoCellcom = slot;
          }
        })
      }
  
      props.showAppLoader(); 
      var isUpdate = await props.updateTechnicianTimeSlot(request);
      props.hideAppLoader(); 
      if(isUpdate.payload.errorCode == 1073){
        getCellcomTimeSlots();
      }
    }

  }

  async function getCellcomTimeSlots(){
    props.showAppLoader();
    let bezeqTimeSlot = props.selectedTimeSlots.find(x => x.type == "BEZEQ");
    var request = {
        OrderId : props.selectedVisit.orderId,
        SelectedBezeqTimeSlot: bezeqTimeSlot,
      }
      var timeSlots = await props.getTechnicianTimeSlots(request);
      if(timeSlots.payload != undefined && timeSlots.payload?.timeSlots?.length > 0){
        await props.showMoreTimeSlots();
        props.hideAppLoader();
        props.goToPage("technicianTimeSlotsCellcomPage")
      }
  }

  async function  onClickShowMoreTimeSlotsBtn(){
      props.showMoreTimeSlots();
  }

  return (
    <div className='technician-time-slots-page'>
        {props.technicianTimeSlotPage?.timeSlots?.length > 0 && <TechnicianTimeSlots onSelectedTimeSlot={onSelectedTimeSlot} updateTechnicianVisit={updateTechnicianVisit} onClickShowMoreTimeSlotsBtn={onClickShowMoreTimeSlotsBtn} showNotChooseTimeSlotErrorMsg={showNotChooseTimeSlotErrorMsg} />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    technicianTimeSlots : state.technicianUpdatesBlock.technicianTimeSlots,
    selectedTimeSlots: state.technicianUpdatesBlock.selectedTimeSlots,
    selectedVisit: state.technicianUpdatesBlock.selectedVisit,
    currentSelectedTimeSlot: state.technicianUpdatesBlock.currentSelectedTimeSlot,
    technicianTimeSlotPage: state.technicianUpdatesBlock.technicianTimeSlotPage
  };
};

const mapDispatchToProps = {
  goToPage,
  pageLoaded,
  reportAnalytics,
  showAppLoader, 
  hideAppLoader,
  setSelectedTimeSlots,
  updateTechnicianTimeSlot,
  showMoreTimeSlots,
  setIsDisplayShowMoreBtn,
  getTechnicianTimeSlots
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianTimeSlotsPage);
